import React from 'react';

export default React.createContext({
  handleError: (message) => message,
  handleSuccess: (message) => message,
});
